import React from "react";
import { navigate } from "gatsby";
import PropTypes from "prop-types";
import { resolve } from "styled-jsx/css";
import { ArticleCard } from "../Article/ArticleCard";
import { getVideoThumbnail } from "./Video";
import { IconButtonLink } from "../Link";
import PlayIcon from "./card-video-play-icon.svg";

export const getVideoUrl = (slug) => `/noissuetv/${slug}/`;

function VideoHeroImage({ videoUrl, slug }) {
    const url = getVideoThumbnail(videoUrl);
    const link = getVideoUrl(slug);
    return (
        <div className="video-hero-image">
            <IconButtonLink
                className="video-hero-image__play"
                to={link}
                icon={PlayIcon}
            />
            <style jsx>{`
                .video-hero-image {
                    background-image: url("${url}");
                    background-size: cover;
                    background-position: center;
                    padding-bottom: 56.25%;
                    height: 0;
                    position: relative;
                }
                .video-hero-image :global(.video-hero-image__play) {
                    position: absolute;
                    bottom: 1em;
                    right: 1em;
                }
            `}</style>
        </div>
    );
}

const { className: videoCardClassName, styles: videoCardStyles } = resolve`
    height: 100%;
    // Hack!!
    :global([data-card-content]) {
        height: 100%;
    }
`;

// TODO: Change link to button when opening modal?
export function VideoCard({ url, slug, postLink, onClick = null, ...rest }) {
    const goToVideo = async (e) => {
        e.stopPropagation();
        await navigate(getVideoUrl(slug));
    };
    return (
        <>
            <ArticleCard
                className={videoCardClassName}
                heroImage={<VideoHeroImage videoUrl={url} slug={slug} />}
                onClick={onClick || goToVideo}
                {...rest}
            />
            {videoCardStyles}
        </>
    );
}

VideoCard.propTypes = {
    slug: PropTypes.string.isRequired,
};
